import React, { Component } from "react";
import { Link } from "gatsby";

class CtaSection extends Component {
  state = {};
  render() {
    return (
      <section id="cta-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h3 className="my-h3-head text-white">Ready to get started ?</h3>
            </div>
            <div className="col-md-6 text-right">
              <Link className="cta-btn " to="/">
                Get a Free Qoute
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CtaSection;
